import { Box } from '@mui/material';
import { useEffect } from 'react';
import FormFields from '../form/FormFields';

const StepCustomStartUp = ({
  fields,
  updateDataCollection,
  dataCollection,
  updateValidation,
  validationSchema,
  prefill,
}) => {
  // optional defaults derived from the data collected so far (e.g. recipient data)
  useEffect(() => {
    if (!prefill) return;
    const defaults = prefill(dataCollection);
    if (defaults && Object.keys(defaults).length > 0)
      updateDataCollection(defaults);
    // runs once when the step is shown
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // check validation
  useEffect(() => {
    validateDataCollection();
  }, [dataCollection, fields]);

  const validateDataCollection = async () => {
    if (!validationSchema) return updateValidation(true);

    try {
      await validationSchema.validate(dataCollection);
      // validation passed for the specific field
      updateValidation(true);
    } catch (err) {
      // validation failed for the specific field
      updateValidation(false);
    }
  };

  return (
    <Box className="flex flex-col gap-4 pt-2">
      <FormFields
        fields={fields}
        updateDataCollection={updateDataCollection}
        dataCollection={dataCollection}
        validationSchema={validationSchema}
        startDataCollection={{}}
      />
    </Box>
  );
};

export default StepCustomStartUp;
